import { INamespaceActionCreator, IReducer } from '@omaze/redux';
import { AnyAction } from 'redux';

import { IFeatureFlagMap } from '../../../interfaces/IFeatureFlagMap';
import { FEATURE_FLAG_ACTIONS } from '../../FeatureFlag.actions';
import {
    createFeatureFlagActionCreatorFactory,
    createFeatureFlagReducerFactory,
} from '../../FeatureFlag.factory';
import { IFeatureFlagState } from '../../FeatureFlag.state';

export const createRegisterAction: INamespaceActionCreator = createFeatureFlagActionCreatorFactory(
    FEATURE_FLAG_ACTIONS.REGISTER,
    (flags: IFeatureFlagMap): IFeatureFlagMap => {
        return flags;
    },
);

export const registerActionReducer: IReducer<IFeatureFlagState> = createFeatureFlagReducerFactory(
    FEATURE_FLAG_ACTIONS.REGISTER,
    (state: IFeatureFlagState, action: AnyAction): void => {
        Object.keys(action.payload).forEach((key: string): void => {
            state.flags[key] = action.payload[key];
        });
    },
);
